import React from "react";

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",   // Fundo branco
        color: "transparent",   // Fundo branco
        borderRadius: "50%",   // Bordas arredondadas
        padding: "10px",       // Espaçamento
        right: "-40px",        // Posicionada fora do carousel (direita)
        zIndex: 1,
        cursor: "pointer",

      }}
      onClick={onClick}
    >
      <span style={{ color: "#af8559", fontSize: "20px" }}>  &#10095;</span> {/* Ícone da seta preta */}
    </div>
    
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        borderRadius: "50%",    // Bordas arredondadas
        padding: "10px",        // Espaçamento para a seta
        left: "-40px",          // Posicionada fora do carousel (esquerda)
        zIndex: 1,              // Mantém as setas à frente das imagens
      }}
      onClick={onClick}
    >
      <span style={{ color: "#af8559", fontSize: "20px" }}>   &#10094;</span> {/* Ícone da seta preta */}
    </div>
  );
};

export { NextArrow, PrevArrow };
